export default "__VITE_ASSET__C14_0xvG__"